import { mockCmsIcon } from '@domgen/dgx-fe-cms';
import { mockAccordionPanel } from '@domgen/dgx-fe-components/accordion';
import { CmsProtectionBenefitsAccordion } from '../../models/protection-details/cms-protection-benefits-accordion.interface';

export const mockCmsProtectionBenefitsAccordion: CmsProtectionBenefitsAccordion =
  {
    accordionPanels: [
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
    ],
    accordionPanelsOOG: [
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
    ],
    accordionCancelPanels: [
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
      { ...mockAccordionPanel, icon: mockCmsIcon, subtitle: 'subtitle' },
    ],
  };
